import * as React from "react";
import { PRIVATE_ROUTE_DETAILS as ROUTES, TRoute } from "constants/routes";
import { USER_ROUTES } from "constants/routes/user";
import { FACILITY_ROUTES } from "constants/routes/facility";
import IconHome from "components/common/icons/IconHome";
import IconSettings from "components/common/icons/IconSettings";
import IconLineChart from "components/common/icons/IconLineChart";
import IconFacility from "components/common/icons/IconFacility";
import { PEERGROUP_ROUTES } from "constants/routes/peergroup";
import IconGroup from "components/common/icons/IconGroup";

export interface TSidebarNavItem {
  name: string;
  icon: any;
  // to?: string;
  href?: string;
  target?: string;
  // requiredRole?: string | string[];
  route?: TRoute;
}

export interface TSidebarNavSection {
  sectionName?: string;
  items: TSidebarNavItem[];
}

export type TSidebarNav = TSidebarNavSection[];

export const sidebarNav: TSidebarNav = [
  {
    items: [
      {
        name: "Home",
        icon: <IconHome />,
        route: ROUTES.HOME,
      },
    ],
  },
  {
    sectionName: "Admin",
    items: [
      {
        name: "Users",
        icon: <IconSettings />,
        route: USER_ROUTES.ADMIN_USERS,
      },
      {
        name: "Facilities",
        icon: <IconFacility />,
        route: FACILITY_ROUTES.ADMIN_FACILITIES,
      },
      {
        name: "Admin Peer groups",
        icon: <IconGroup />,
        route: PEERGROUP_ROUTES.ADMIN_PEERGROUPS,
      },

      // {
      //   name: "Admin CPD",
      //   icon: <IconNotebook />,
      //   route: ROUTES.ADMIN_PLANS_LIST,
      // },

      {
        name: "Admin Reports",
        icon: <IconLineChart />,
        route: ROUTES.ADMIN_REPORTS,
      },
    ],
  },
];
